var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.3 61.66C354.1 29.43 301.9 29.43 269.7 61.66L77.66 253.7C27.76 303.6 27.76 384.4 77.66 434.3C127.6 484.2 208.4 484.2 258.3 434.3L410.3 282.3C413.5 279.2 418.5 279.2 421.7 282.3C424.8 285.5 424.8 290.5 421.7 293.7L269.7 445.7C213.5 501.8 122.5 501.8 66.34 445.7C10.2 389.5 10.2 298.5 66.34 242.3L258.3 50.34C296.8 11.87 359.2 11.87 397.7 50.34C436.1 88.81 436.1 151.2 397.7 189.7L213.9 373.4C189 398.3 148.2 395.1 126.2 368.6C107.5 345.1 109.3 311.3 130.6 290.1L282.3 138.3C285.5 135.2 290.5 135.2 293.7 138.3C296.8 141.5 296.8 146.5 293.7 149.7L141.9 301.4C126.4 316.9 125.1 341.5 138.7 358.6C154.7 378.6 184.5 380.2 202.6 362.1L386.3 178.3C418.6 146.1 418.6 93.88 386.3 61.66V61.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.1d668d97c4d4108de361ce5154227171.svg";
export { ForwardRef as ReactComponent };